export default __webpack_public_path__ + "static/media/image_delete.7da827fb.png";